<div class="modal-header">
	<h2 i18n="@@invoices.invoice_qr_code">Invoice QR code</h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
		</svg>
	</button>
</div>
<div class="modal-footer">
	<qr-code value="{{ invResponse.url }}" size="200" errorCorrectionLevel="M"></qr-code>
	<span i18n="@@invoices.scan_qr_code_pay_invoice">Scan QR code to pay invoice</span>
</div>
